import React from 'react';
import Button from '../elements/Button';
import Text from '../elements/TextComponent';

type RecentMessage = {
  message: string;
  botId: string;
};

type RecentMessagesProps = {
  recentMessages: RecentMessage[];
  onViewClick?: (botId: string) => void;
};

const RecentMessages: React.FC<RecentMessagesProps> = ({ recentMessages, onViewClick }) => {
  return (
    <div
      style={{
        height: '300px',
        overflowY: 'auto',
        display: 'flex',
        flexDirection: 'column',
        gap: '12px',
      }}
      className="typer-scroll-container"
    >
      <Text
        text="Recent Messages"
        textAlign="left"
        fontSize="16px"
        color={'#555'}
        />

      {recentMessages.length === 0 ? (
        <Text
          text="No recent messages."
          fontSize="14px"
          fontWeight={400}
          textAlign="left"
          color="#888"
        />
      ) : (
        recentMessages.map((msg, idx) => (
          <div
            key={`${msg.botId}-${idx}`}
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              backgroundColor: 'var(--tint)',
              padding: '10px 14px',
              borderRadius: '16px',
              boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
            }}
          >
            <Text
              text={msg.message}
              fontSize="14px"
              fontWeight={500}
              textAlign="left"
              color="#333"
              style={{ flex: 1, marginRight: '10px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
            />
            <Button
              label="View"
              height="36px"
              width="80px"
              fontSize="14px"
              backgroundColor="var(--primary)"
              onClick={() => onViewClick?.(msg.botId)}
            />
          </div>
        ))
      )}
    </div>
  );
};

export default RecentMessages;
